/**
 * What a link's `aff_id` parts say about who made the link. Signup splits `aff_id` (`<affiliate>_<campaign>_<site>`)
 * and stores each part on the player, so these rules read a player row as well as a link.
 *
 * Its own module, with no imports, so a pure layer (the Players roster) shares the rules with `resolveAttribution` and
 * the Website tab without pulling the tracking links or analytics APIs in.
 */

/** An affiliates-platform campaign number: what signup stores as a player's `campaign` when they came through an
 *  affiliate's link (all digits). Studio's own tracking-link tokens are never all digits, so the two never collide. */
export const isAffiliateCampaignNo = (campaign: string | null | undefined): boolean =>
  /^\d+$/.test((campaign ?? '').trim());

/** The owner's own token on Studio's owner-tracked links (`ow` + 6), as opposed to an affiliates platform number. */
export const isOwnerTracked = (affiliate: string): boolean => /^ow[0-9a-z]{6}$/.test(affiliate);
